/**
 * Created by charles on 2018/1/11.
 */
export default {
    '1': {
        name: '贝壳微校后台管理系统',
        logo: '/static/wx/pc/images/icon_logo.png',
        className: 'weixiao-header',
        bgClassName: 'weixiao-bg',
        mobile_config: {
            title: '微校登录',
            logo: '/static/m/image/wx_logo.svg',
            className: 'wx-header'
        }
    },
    '2': {
        name: '贝壳经纪学堂后台管理系统',
        logo: '/static/images/icon_zd.svg',
        className: 'zhidao-header',
        bgClassName: 'zhidao-bg',
        mobile_config: {
            title: '登录',
            logo: '/static/m/image/logoNEW.png',
            className: 'zd-header',
            showUserProtocol: true      //显示<贝壳经纪学堂用户使用协议>
        }
    }
}


// WEBPACK FOOTER //
// ./src/main/resources/static/config/site.js